import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';

const FieldLabel = styled.label`
    display: block;
    color: ${COLORS.mlbWhite};
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 10px;
`;

export default FieldLabel;
